import { render } from "./itemPrecarioEditPopUp.vue?vue&type=template&id=32a78f81&scoped=true"
import script from "./itemPrecarioEditPopUp.vue?vue&type=script&lang=js"
export * from "./itemPrecarioEditPopUp.vue?vue&type=script&lang=js"

import "./itemPrecarioEditPopUp.vue?vue&type=style&index=0&id=32a78f81&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a78f81"]])

export default __exports__